import { decodeTokenPayload } from './tokenPayload';

/**
 * The access-token claim the platform sets while an account still holds its first (provisioned) password
 * (`JwtClaims.PASSWORD_CHANGE_REQUIRED`).
 */
export const PASSWORD_CHANGE_CLAIM = 'pwd_chg';

/** The platform's error code for a request refused because the password must be changed first. */
export const PASSWORD_CHANGE_REQUIRED_CODE = 'PASSWORD_CHANGE_REQUIRED';

/**
 * Whether this token belongs to a user who must change their password before anything else.
 *
 * Read from the token rather than stored beside it, so every way a session is (re)built -- password sign-in,
 * OTP sign-in, a silent refresh, a page reload -- agrees with the server without a flag of its own to keep in
 * step. Like every claim read on this side it decides what the screen offers, not what is allowed: the
 * platform refuses everything but Change Password and sign-out for the same token, whatever the client does.
 */
export function tokenRequiresPasswordChange(token: string | null | undefined): boolean {
  const payload = decodeTokenPayload(token);
  if (typeof payload !== 'object' || payload === null) return false;
  return (payload as Record<string, unknown>)[PASSWORD_CHANGE_CLAIM] === true;
}

/** Whether a failed response is the platform's "change your password first" refusal. */
export function isPasswordChangeRequiredResponse(data: unknown): boolean {
  if (typeof data !== 'object' || data === null) return false;
  const body = data as { code?: unknown; errorCode?: unknown };
  return body.code === PASSWORD_CHANGE_REQUIRED_CODE || body.errorCode === PASSWORD_CHANGE_REQUIRED_CODE;
}
